export const bff_prefix = '/forum_api';

export const OFFICIAL = '官方公告'; // 公告面板的名称

export const STD_DATE_FORMAT_RE =
  /^(\d{4,4})-(\d{2,2})-(\d{2,2}) \d{2,2}:\d{2,2}:\d{2,2}$/;
